module.exports = __webpack_public_path__ + "img/pengcheng.e32802d2.png";